export enum EAuthUrls {
  AUTH = 'auth',
  SIGNUP = 'signup',
  FORGOT_PASSWORD = 'forgot-password',
  TEMPORARY_PASSWORD = 'temporary-password',
  LOGIN = 'login',
  IS_ADMIN = 'is-admin',
  SSO_CONFIGURATION = 'sso-configuration',
  AUTHENTICATION_FLOWS = 'authentication-flows',
}
